import { LocaleDirection } from './types'

const rtlLanguages = ['fa', 'ar', 'he']

export const localeToDirection = (locale: string): LocaleDirection => {
  if (!locale) {
    return 'ltr'
  }

  const localeLanguage = locale?.toLowerCase().split('-')?.[0]

  return rtlLanguages.includes(localeLanguage) ? 'rtl' : 'ltr'
}
